import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-header-navi-child-on-admin__wrapper"
}
const _hoisted_2 = {
  ref: "targetElement",
  class: "p-the-header-navi-child-on-admin"
}
const _hoisted_3 = ["href", "onMouseover"]
const _hoisted_4 = { class: "p-the-header-navi-child-on-admin__link__text" }
const _hoisted_5 = { class: "p-the-header-navi-child-on-admin__link__notification" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabelNewArrivalCount = _resolveComponent("TextLabelNewArrivalCount")!
  const _directive_touch = _resolveDirective("touch")!

  return (_ctx.childList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", {
            ref: "targetContentsElement",
            class: _normalizeClass([{ 'p-the-header-navi-child-on-admin__active-list': _ctx.isOpen }, "p-the-header-navi-child-on-admin__list"])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, ({ label, url, hasNotification }, key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: key,
                class: "p-the-header-navi-child-on-admin__list__item"
              }, [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  class: "p-the-header-navi-child-on-admin__link",
                  href: url,
                  style: _normalizeStyle({ color: _ctx.hoverColor[_ctx.isHover(key)] }),
                  onMouseover: ($event: any) => (_ctx.mouseover(key)),
                  onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseleave && _ctx.mouseleave(...args)))
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(label), 1),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_TextLabelNewArrivalCount, {
                      count: _ctx.getNotificationCount(hasNotification)
                    }, null, 8, ["count"])
                  ])
                ], 44, _hoisted_3)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]))
            }), 128))
          ], 2)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}